/* global axios */
import ApiClient from '../ApiClient';

class PilotWechatCrawlRunMode extends ApiClient {
  constructor() {
    super('pilot/wechat_crawl_run_mode', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  generateCrawlUrl(kbId = null) {
    const params = kbId ? { kb_id: kbId } : {};
    return axios.get(`${this.url}/generate_crawl_url`, { params });
  }
}

export default new PilotWechatCrawlRunMode();
